import React from 'react';
import { useTranslate } from '@bynder/localization';
import { Flex } from '@bynder/design-system';
import { IconCheck } from '@bynder/icons';
import { VariationItemBySizeIdType } from 'packages/variation-export/types';
import VariationsThumbnail from '../sidebar/variations/VariationsThumbnail';
import { VariationDropdownItem, VariationDropdownItemCheck, VariationDropdownItemInner } from './previewHeader.styled';

type Props = {
    sizes: VariationItemBySizeIdType;
    id: string;
    name: string;
    created: string;
    onSelect: (event: any, id: any) => void;
    isIncluded: boolean;
    isInvalid: boolean;
    isCurrentVariation: boolean;
};

const PreviewHeaderVariationDropdownItem = ({
    sizes,
    id,
    name,
    created,
    onSelect,
    isIncluded,
    isInvalid,
    isCurrentVariation,
}: Props) => {
    const { translate } = useTranslate();

    return (
        <VariationDropdownItem>
            <VariationDropdownItemInner onClick={(e) => onSelect(e, id)}>
                <Flex alignItems="center">
                    <VariationsThumbnail
                        variationId={id}
                        sizes={sizes}
                        isInvalid={isInvalid}
                        isCurrentVariation={isCurrentVariation}
                    />
                    <div className="variation--dropdown-item-name">
                        <span>{name}</span>
                        <span>{translate('design.header.variations.dropdown.edited', { created })}</span>
                    </div>
                    <VariationDropdownItemCheck>{isIncluded && <IconCheck />}</VariationDropdownItemCheck>
                </Flex>
            </VariationDropdownItemInner>
        </VariationDropdownItem>
    );
};

export default PreviewHeaderVariationDropdownItem;
